import React from "react";
import { Link } from "react-router-dom";

export default function TemplateRow({ item, displayNo }) {
  return (
    <div className="stdcouncil-template-row">
      <div className="stdcouncil-template-col-no">{displayNo}</div>

      <div className="stdcouncil-template-col-title">
        <Link
          to={`/documents/student-council/template/${item.id}`}
          className="stdcouncil-template-title-link"
        >
          {item.title}
        </Link>
      </div>

      <div className="stdcouncil-template-col-writer">{item.writer}</div>
      <div className="stdcouncil-template-col-date">{item.date}</div>
      <div className="stdcouncil-template-col-view">{item.view}</div>
    </div>
  );
}